/** ⚠️ Legacy element type identifier, use CONCEPT_INPUT_ELEMEN!
 * @deprecated
 */
export const VALUESET_INPUT_ELEMENT = "valueset-input-element";
/** Concept input element type identifier */
export const CONCEPT_INPUT_ELEMENT = "concept-input-element";
